export default __webpack_public_path__ + "static/media/left-arrow.da21225b.svg";